var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-0.5 -0.5 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Undo-Left--Streamline-Solar-Broken",
    height: 16,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Undo Left Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.375h6.875c1.16825 0 1.7524375 0 2.1875 0.25120625 0.2850625 0.1645625 0.5217499999999999 0.40125625 0.6863125000000001 0.6862875C12.5 5.74759375 12.5 6.33175 12.5 7.5s0 1.7523749999999998 -0.2511875 2.1875c-0.1645625 0.2850625 -0.40125 0.5217499999999999 -0.6863125000000001 0.6863125000000001C11.1274375 10.625 10.54325 10.625 9.375 10.625H5.00000625M2.5 4.375l1.875 -1.875M2.5 4.375l1.875 1.875",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoLeft);
export default __webpack_public_path__ + "static/media/Undo-Left.9e915a6bc374adcc0f2f0c88c060d87f.svg";
export { ForwardRef as ReactComponent };